import { IconProps } from "../../icons/dto";

export function ArrowsDown(props: IconProps) {
    const { size, color } = props;
    return (
        <svg width={size ?? "24"} height={size ?? "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 4V15M17 15L13 11M17 15L21 11M7 4V20M7 20L3 16M7 20L11 16" stroke={color ?? "black"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}